import { MouseEventHandler, ReactNode } from "react"
import styles from "./TabLink.module.scss"

interface Props {
  title: ReactNode;
  selected: boolean;
  onClick: MouseEventHandler;
  onClose?: MouseEventHandler;
}

/**
 * Tab selector intended to be used in `TabsContainer`. Accepts `onClick` listener
 * for implementation of custom tab selection logic. See `TabLink` if navigation
 * to a URL is needed.
 */
export function TabButton({
  title,
  selected,
  onClick,
  onClose,
}: Props) {
  return <div
    className={styles.tab}
    data-selected={selected}
    onClick={onClick}
  >
    {title}
    {onClose && (
      <button
        className={styles.closeButton}
        onClick={(e) => {
          e.stopPropagation();
          onClose(e);
        }}
        style={{ background: "none", marginLeft: "0.5rem" }}
      >
        <i className="fa-solid fa-xmark" style={{ fontSize: "1.25rem" }} />
      </button>
    )}
  </div>
}